import axios from "axios";
import { MutableRefObject, Ref, useCallback, useEffect, useMemo, useRef, useState } from "react"; 
import { getCurrentIssueNumber, getNextIssueNumber } from "../utils/util";
import { TabProps } from "../components/LotteryTab";
// import { TabProps } from "@chatui/core";
import sleep from 'sleep-promise'
import _, { StringChain, sortedLastIndex } from 'lodash'
import moment from "moment";
import { calculateWinRate, calculateWinTrend } from "./useDraw";
import stores from "../state"; 
export const base = 'https://wingolottery.win/' 


export const usePlanners = ()=>{
    const [planners,setPlanners] = useState();
    const [loadingStatus,setLoadingStatus] = useState(true);
    const loadCallback = useCallback(async ()=>{
        try{
             const {data:planners} = await axios(base+'planners?r='+new Date().getTime())
             setPlanners(planners)
            //  stores.TodoList.planners = planners
        }catch(e){
            console.error('e',e)
        }finally{
            setLoadingStatus(false)
        }
    },[ ])
    useEffect(()=>{
        loadCallback()
    },[loadCallback])
    return {planners,loadingStatus,refreshDrawResult:loadCallback}
} 

const compareRef = (ref:MutableRefObject<{pids:string[],planType:string,typeId:string,lottery:string}>,{pids,planType,typeId,lottery}:{pids:string[],planType:string,typeId:string,lottery:string})=>{
    if(ref.current.pids[0] !== pids[0]){
        return false
    }
    if(ref.current.planType !== planType){
        return false
    }
    if(ref.current.typeId  !== typeId){
        return false
    }
    if(ref.current.lottery !== lottery){
        return false
    }
    return true
} 

export const useLatestPlanNPlanHistory = (lottery:string,typeId:string,issueNumber:string, pids:string[],planType:string)=>{
    const {hitProfiles,loadPlanHistories} = usePlanHistories(lottery,typeId,issueNumber, pids,planType)
    const {latestPlans,refreshLatestPlan} = useLatestPlan(lottery,typeId,issueNumber, pids,planType)
    const [sortedLatestPlans,setSortedLatestPlans] = useState<PlanType[]>()
    const [_hitProfiles,setHitProfiles] = useState<HitProfile[]>()
    useEffect(()=>{
        console.log('useLatestPlanNPlanHistory loadPlanHistories changed',new Date())
    },[loadPlanHistories])
    
    useEffect(()=>{ 
        console.log('useLatestPlanNPlanHistory',latestPlans,hitProfiles,hitProfiles?.length,latestPlans?.length)
        const result:PlanType[] = []
        if(!hitProfiles || hitProfiles.length===0){
            return
        }
        if(!latestPlans || latestPlans.length===0){
            return
        }
        // @ts-ignore
        const issueNumberMatch = BigInt(latestPlans[0].issueNumber)-1n == BigInt(hitProfiles[0].planner.trend.draws[0].issueNumber)
        // @ts-ignore
        const planTypeMatch =  hitProfiles[0].planner.planType == latestPlans[0].planType
        const matches = issueNumberMatch && planTypeMatch;


        // @ts-ignore
        console.log('latestPlans[0].issueNumber',latestPlans[0].issueNumber,hitProfiles[0].planner.trend.draws[0].issueNumber,'matches',matches,'issueNumberMatch',issueNumberMatch,'planTypeMatch',planTypeMatch, 'planType',hitProfiles[0].planner.planType,latestPlans[0].planType)
        // @ts-ignore
        if(!matches){
            return
        }
        hitProfiles.forEach(profile=>{
            result.push(latestPlans.filter(plan=>{
                return plan.pid === profile.planner.pid
            })[0])
        })
        // @ts-ignore
        // console.log('useLatestPlanNPlanHistory result',latestPlans[0].issueNumber,hitProfiles[0].planner.trend.draws[0].issueNumber,lottery,typeId,planType,result)
        setSortedLatestPlans(result)
        setHitProfiles([...hitProfiles])
        console.log('useLatestPlanNPlanHistory hitProfiles',result,hitProfiles)
    },[hitProfiles,latestPlans])
    return {hitProfiles:_hitProfiles,sortedLatestPlans,loadPlanHistories,refreshLatestPlan}
}

type HitProfile = {hitRate:string,hitTrend:boolean[],planner?:{plannerName:string,pid:string}}
export const usePlanHistories = (lottery:string,typeId:string,latestIssueNumber:string,pids:string[],planType:string)=>{
    const [planHistories,setPlanHistories] = useState<any[]>();
    const [hitProfiles,setHitProfiles] = useState<HitProfile[]>();
    const [loadingStatus,setLoadingStatus] = useState(true);
    const watchRef = useRef<{pids:string[],planType:string,typeId:string,lottery:string}>()
    const loadPlanHistories = useCallback(async ()=>{
        try{
            if(!lottery){
                return 
            }
            if(!planType){
                return
            }
            watchRef.current = {pids,planType,typeId,lottery}
            console.log('usePlanHistories','pids',pids,'lottery',lottery,'planType',planType)
            setLoadingStatus(true)
            // let result
            for(let i =0;i<10;i++){
                // const compareResult = compareRef(watchRef,{pids,planType,typeId,lottery})
                // console.log('compareResult',compareResult)
                // if(!compareResult){
                //     return
                // }
                // console.log('useDrawResult1 tabRef.current.path !== tab.path',tabRef.current.path,tab.path)
                try{ 
                    if(pids?.length>0){
                        // 获取预测师的彩种+预测类型预测
                        const {data:plans} = await axios(base+`${lottery}_${typeId}_${getCurrentIssueNumber(parseInt(typeId))}_${pids[0]}_${planType}_plans?r=`+new Date().getTime());
                        plans.trend.draws = plans.trend.draws.filter((draw:any)=>!!draw);
                        plans.trend.plans = plans.trend.plans.filter((plan:any)=>!!plan);
                        plans.trend.draws.forEach((d:any,i:number)=>{
                            d.plan = plans.trend.plans[i]
                        })
                        setHitProfiles([{hitRate:calculateWinRate(plans.trend.draws),hitTrend:calculateWinTrend(plans.trend.draws)}]) 
                        const {data:latestPlan} = await axios(base+`${lottery}_${typeId}_${getNextIssueNumber(parseInt(typeId))}_${pids[0]}_${planType}_plan`)
                        setPlanHistories([
                            [{issueNumber:latestPlan?.issueNumber, plan:latestPlan,},...plans.trend.draws]
                        ]) 
                    }else{
                        // 获取彩种+预测类型的预测
                        const {data:planners} = await axios(base+`${lottery}_${typeId}_${getCurrentIssueNumber(parseInt(typeId))}_${planType}_plans?r=`+new Date().getTime())
                        planners.forEach((planner:any)=>{
                            planner.trend.draws.forEach((d:any,i:number)=>{
                                d.plan = planner.trend.plans[i]
                            })
                        })
                        const _plannerProfiles = planners.map((r:any)=>{ 
                            return {hitRate:calculateWinRate(r.trend.draws),hitTrend:calculateWinTrend(r.trend.draws),planner:r}
                        }).sort((a:any,b:any)=>{
                            return -parseInt(a.hitRate) + parseInt(b.hitRate)
                        })
                        setHitProfiles(_plannerProfiles)  
                         
                    }    
                    break;
                }catch(e){
                    console.error('e',e)
                    await sleep(2000)
                }
            }
             
            // const latestPlans = await Promise.all(pids.map(async pid=>{
                
            //     const {data:planDetail} = await axios(base+`${lottery}_${typeId}_${getNextIssueNumber(parseInt(typeId))}_${pid}_${planType}_plan`)
            //     // console.log('useLatestPlan',planDetail,base+`${lottery}_${typeId}_${getNextIssueNumber(parseInt(typeId))}_${pid}_${planType}_plan`)
            //     return planDetail
            // })) 
            // 下一期预测
            // const {data:planners} = await axios(base+`${lottery}_${typeId}_${getNextIssueNumber(parseInt(typeId))}_${planType}_pending_plans`)
            // console.log('latestPlans',planners)
            // setPlanHistories(result.map((r,i)=>{
            //     return  [{issueNumber:latestPlans?.[i].issueNumber, plan:latestPlans?.[i]},...r.trend.draws]
            // }))

        }catch(e){
            console.error('e',e)
        }finally{
            setLoadingStatus(false)
        }
    },[pids,planType,typeId,lottery])
    useEffect(()=>{
        loadPlanHistories()
    },[loadPlanHistories])
    return {hitProfiles,planHistories, loadingStatus,loadPlanHistories}
} 

export type PlanType = {
    pid:string,
    planType:string,
    plannerName:string,
    createTime:string,
    issueNumber:string,
    content:{
        bs:string;
        oe:string;
        numbers:number[];
    }
}
// 有pid代表获取  没有pid获取所有预测师的最新预测
export const useLatestPlan = (lottery:string,typeId:string,issueNumber:string, pids:string[],planType:string)=>{
    const [latestPlans,setLatestPlans] = useState<PlanType[]>();
    // const [hitProfiles,setHitProfiles] = useState<{hitRate:string,hitTrend:boolean[]}[]>();
    const [loadingStatus,setLoadingStatus] = useState(true);
    const refreshLatestPlan = useCallback(async ()=>{
        try{ 
            console.log('useLatestPlan',pids,planType,lottery,typeId)
            if(!planType){
                return
            }
            // if(!pids){
            //     return 
            // }
            // if(!issueNumber){
            //     return 
            // }
            if(!lottery){
                return
            }
            setLoadingStatus(true)
            for(let i = 0 ;i < 10;i++){
                try{
                    if(pids?.length > 0){
                        const {data:planDetail} = await axios(base+`${lottery}_${typeId}_${getCurrentIssueNumber(parseInt(typeId))}_${pids[0]}_${planType}_plan`)
                        setLatestPlans([planDetail])
                    }else{
                        const {data:planners} = await axios(base+`${lottery}_${typeId}_${getNextIssueNumber(parseInt(typeId))}_${planType}_pending_plans?r=`+new Date().getTime())
                        setLatestPlans(planners)
                    } 
                    break;
                }catch(e){
                    
                    console.error('e',e)
                    await sleep(2000)
                }
            }
            // const result = await Promise.all(pids.map(async pid=>{
            //     const {data:planDetail} = await axios(base+`${lottery}_${typeId}_${issueNumber}_${pid}_${planType}_plan`)
            //     console.log('useLatestPlan',planDetail,base+`${lottery}_${typeId}_${issueNumber}_${pid}_${planType}_plan`)
            //     return planDetail
            // })) 
            
            // console.log('useLatestPlan',planDetail,base+`${lottery}_${typeId}_${issueNumber}_${planType}_plan`)
            // return planDetail
            
        }catch(e){
            console.error('e',e)
        }finally{
            setLoadingStatus(false)
        }
    },[pids,planType,
        // issueNumber,
        typeId,lottery])
    useEffect(()=>{
        refreshLatestPlan()
    },[refreshLatestPlan])
    return {latestPlans,loadingStatus,refreshLatestPlan}
} 